/* import __COLOCATED_TEMPLATE__ from './guidance-support-info.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { showNewMessageInIntercomWidget } from 'embercom/lib/intercom-widget-helper';

interface Args {}

interface Signature {
  Args: Args;
}

export default class BillingStripeMigrationGuidanceSupportInfoComponent extends Component<Signature> {
  @service declare appService: AppService;
  @service declare customerService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;

  translationKey = 'billing.migrations.migration_help.';

  @action
  openMessenger() {
    showNewMessageInIntercomWidget();
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      context: 'proactive_migrations',
      place: 'migration_help',
      object: 'open_messenger_button',
    });
  }

  get isAnnuallyInvoiced() {
    return this.customerService.customer?.subscription?.isBilledAnnually;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::StripeMigration::MigrationSubcontent::GuidanceSupportInfo': typeof BillingStripeMigrationGuidanceSupportInfoComponent;
  }
}
